/*eslint-disable */
import { useEffect, useState } from "react";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import ArrowCircleRightIcon from "@mui/icons-material/ArrowCircleRight";
import { Box, Button, List, styled, useMediaQuery } from "@mui/material";
import DraggableComponentItems from "./DraggableComponentItems";
import DraggableItemsLoader from "./DraggableItemsLoader";

const TopicGenerateBoxOne = styled(Box)(({ theme }) => ({
  "& .CopyBtnWrapper": {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "15px",
    "& button": {
      "& svg": {
        fontSize: "16px",
        marginRight: "5px",
      },
    },
    "& .CollapseIcon": {
      fontSize: "35px",
      cursor: "pointer",
    },
  },
  "& ul": {
    padding: "0",
    "& li": {
      border: "1px solid" + theme.palette.primary.main,
      borderRadius: "10px",
      marginBottom: "15px",
      padding: "22px 18px 14px",
      position: "relative",
      // "&:last-of-type": { marginBottom: "0" },
      "& .TopicsWrapper": {
        flex: "1",
        "&::selection": {
          userSelect: "none",
        },
        "& h4": {
          fontSize: "16px",
          fontWeight: 700,
          marginBottom: "8px",
        },
        "& p": {
          fontSize: "14px",
          marginBottom: "15px",
          "& .ReadMoreLess": {
            color: theme.palette.primary.main,
            cursor: "pointer",
          },
        },
        "& .GenerateCountWrapper": {
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "flex-start",
          gap: "15px",
          "& button": {
            minWidth: "94px",
            minHeight: "36.13px",
          },
        },

        "& .TopIconBarWrapper": {
          position: "absolute",
          top: "0",
          left: "0",
          width: "100%",
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-between",
          padding: "0 10px",
          // opacity: "0",
          "& .UpDownIcon": {
            backgroundColor: theme.palette.background.default,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            "& svg": {
              fontSize: "20px",
              marginRight: "5px",
              cursor: "pointer",
            },
          },
          "& .MinusIcon": {
            backgroundColor: theme.palette.background.default,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            "& svg": {
              fontSize: "24px",
              cursor: "pointer",
            },
          },
        },
        "& .BottomIconBarWrapper": {
          position: "absolute",
          bottom: "3px",
          right: "5px",
          "& svg": {
            cursor: "pointer",
            "&.LoadingAnimated": {
              animation: "RotateAnimated 1s linear infinite",
              "@keyframes RotateAnimated": {
                "0%": { transform: "rotate(0deg)" },
                "100%": { transform: "rotate(360deg)" },
              },
            },
          },
        },
      },
    },
  },
}));

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

const getItemStyle = (isDragging, draggableStyle) => ({
  ...draggableStyle,
  ...(isDragging && { opacity: "0.5" }),
});

const getListStyle = isDraggingOver => ({});

function DragDropList({
  collapse,
  handleCollapse,
  loading,
  items,
  setItems,
  advanceSubtopicData,
  isDisable,
  setIsDisable,
  handleCompleteButtonClick,
  setGeneratedItems,
  handleDelete,
  comLoading,
}) {
  const isMobile = useMediaQuery("(max-width: 900px)");
  const [expandedIndex, setExpandedIndex] = useState(null);
  const onDragEnd = result => {
    if (!result.destination) {
      return;
    }
    const newItems = reorder(items, result.source.index, result.destination.index);
    setItems(newItems);
  };

  const handleReadMore = index => {
    if (expandedIndex === index) {
      setExpandedIndex(null);
    } else {
      setExpandedIndex(index);
    }
  };

  const handleReadLess = () => {
    setExpandedIndex(null);
  };

  useEffect(() => {
    if (items.length < 1) {
      setIsDisable(true);
    } else {
      setIsDisable(false);
    }
  }, [items]);

  return (
    <>
      <TopicGenerateBoxOne>
        <Box className="CopyBtnWrapper">
          <Button onClick={handleCompleteButtonClick} disabled={isDisable}>
            Complete
          </Button>
          {!isMobile &&
            (collapse ? (
              <ArrowCircleLeftIcon onClick={handleCollapse} className="CollapseIcon" titleAccess="Show Topics Bar" />
            ) : (
              <ArrowCircleRightIcon onClick={handleCollapse} className="CollapseIcon" titleAccess="Hide Topics Bar" />
            ))}
        </Box>
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="droppable">
            {(provided, snapshot) => (
              <List ref={provided.innerRef} style={getListStyle(snapshot.isDraggingOver)}>
                {items?.map((item, index) => (
                  <DraggableComponentItems
                    key={item.id}
                    item={item}
                    // loading={loading}
                    index={index}
                    expandedIndex={expandedIndex}
                    handleReadMore={handleReadMore}
                    handleReadLess={handleReadLess}
                    handleDelete={handleDelete}
                    getItemStyle={getItemStyle}
                    advanceSubtopicData={advanceSubtopicData}
                    handleCompleteButtonClick={handleCompleteButtonClick}
                    setGeneratedItems={setGeneratedItems}
                  />
                ))}
                {loading && comLoading && <DraggableItemsLoader Topic={true} Content={true} />}
                {provided.placeholder}
              </List>
            )}
          </Droppable>
        </DragDropContext>
      </TopicGenerateBoxOne>
    </>
  );
}

export default DragDropList;
